import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["href", "data-job-id", "title"]
const _hoisted_2 = ["data-job-id"]
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_socket = _resolveComponent("ui-socket")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "itemDiv",
    class: "job-list-row-item hover-reveal-hidden",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    (_openBlock(), _createBlock(_component_ui_socket, {
      key: 'before/' + _ctx.job.id,
      section: "job-browse-item",
      location: "before-job-name",
      "socket-data": { job: _ctx.loadedJob }
    }, null, 8, ["socket-data"])),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadedJob.meta, (meta) => {
      return (_openBlock(), _createBlock(_component_ui_socket, {
        key: 'before/' + _ctx.job.id + '/' + meta.name,
        location: `before-job-name:meta:${meta.name}`,
        section: "job-browse-item",
        "socket-data": { job: _ctx.job, meta: meta.data }
      }, null, 8, ["location", "socket-data"]))
    }), 128)),
    (_ctx.showJobsAsLinks)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.jobLinkHref(_ctx.job),
          "data-job-id": _ctx.job.uuid,
          class: "link-quiet job-name",
          title: _ctx.job.jobName
        }, _toDisplayString(_ctx.job.jobName), 9, _hoisted_1))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn-link link-quiet",
          "data-job-id": _ctx.job.uuid,
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleJobSelection && _ctx.handleJobSelection(...args)), ["prevent"]))
        }, _toDisplayString(_ctx.job.jobName), 9, _hoisted_2)),
    (_ctx.job.description)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "text-secondary job-description",
          title: _ctx.job.description
        }, _toDisplayString(_ctx.shortDescription), 9, _hoisted_3))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadedJob.meta, (meta) => {
      return (_openBlock(), _createBlock(_component_ui_socket, {
        key: 'after/' + _ctx.job.id + '/' + meta.name,
        location: `after-job-name:meta:${meta.name}`,
        section: "job-browse-item",
        "socket-data": { job: _ctx.job, meta: meta.data }
      }, null, 8, ["location", "socket-data"]))
    }), 128)),
    (_openBlock(), _createBlock(_component_ui_socket, {
      key: 'after/' + _ctx.job.id,
      location: "after-job-name",
      section: "job-browse-item",
      "socket-data": { job: _ctx.loadedJob }
    }, null, 8, ["socket-data"]))
  ], 512))
}